import { render } from "./CardBody.vue?vue&type=template&id=4f2cda0c&scoped=true"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"

import "./CardBody.vue?vue&type=style&index=0&id=4f2cda0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2cda0c"]])

export default __exports__